const AddHomeBannerStyle = () => {
  const itens = document.getElementsByClassName('main-slider-item__banner');
  Object.keys(itens).forEach((key) => {
    const element = itens[key];
    element.style.backgroundImage = `url("${element.dataset.banner}")`;
  });
};

export default AddHomeBannerStyle;



// WEBPACK FOOTER //
// /app/app/assets/javascripts/packs/home/homeBannerImages.js